<template>
  <div class="gameplan">
    <ContentHeader path-set-type="append" :gameplan-nav="false" />
    <div class="content-wrapper" v-loading="loading">
      <!-- 新建活动 -->
      <div class="activity_new">
        <div class="normal_title">活动主题信息</div>
        <!-- <div class="operation_btn_box">
          <div class="operate_btn operate_btn_white" v-if="isOwner" @click="addThemeInfo">修改活动主题</div>
        </div> -->
        <div class="operation_btn_box" v-if="themeDetailStatus===0||themeDetailStatus==400">
          <div class="operate_btn operate_btn_red" v-if="isBU&&!isOwner&&isBUChangeAssign" @click="gotoConfirmedDetail('/gameplan/quotaWait-confirmed-detail')">调整额度</div>
          <div class="operate_btn operate_btn_white" v-if="isOwner" @click="connectVendor">关联供应商</div>
          <div class="operate_btn operate_btn_white" v-if="isOwner" @click="addThemeInfo">修改活动主题</div>
        </div>
        <div class="pr-box">
          <div class="pr-item space-between">
            <div class="pr-title"> {{themeBasic.themeName}} <span class="pr-level">{{ getOrgLevel }}</span> </div>
            <div> <span class="font-weight-bold">活动时间：</span> {{ themeBasic.themeStartTime | parseTime("{y}-{m}-{d}") }} {{themeBasic.themeStartTime?'-':''}}  {{ themeBasic.themeEndTime | parseTime("{y}-{m}-{d}") }} </div>
          </div>
          <div class="flex">
            <div style="margin-right:50px;margin-top:12px;"><span class="font-weight-bold">PR信息：</span>{{prInfo}}</div>
            <div style="margin-top:12px;"><span class="font-weight-bold">品牌信息：</span>{{brandInfo}}</div>
          </div>
          <div class="pr-item">
            <div style="margin-right:50px">活动执行数据收集模板 <el-button type="text" style="margin-left:10px;" @click="$refs['ConfigureExecutionData'].handleOpen()">配置详情</el-button></div>
            <div>
              <span>活动执行手册</span>
              <el-button v-if="themeBasic.manualFileName" type="text" style="margin-left:10px;" @click="openFile('manualFileUri')">{{ themeBasic.manualFileName }}</el-button>
              <el-button type="text" style="margin-left:10px;" v-else>暂无附件</el-button>
            </div>
          </div>
          <!-- <el-row>
            <el-col :span="6">
              活动执行数据收集模板 <el-button type="text" style="margin-left:10px;" @click="$refs['ConfigureExecutionData'].handleOpen()">{{ isOwner?'配置详情':'配置详情' }}</el-button>
            </el-col >
            <el-col :span="6" v-if="themeBasic.manualFileUri">
              <span>活动执行手册</span>
              <el-button type="text" style="margin-left:10px;" @click="openFile('manualFileUri')">{{ themeBasic.manualFileName }}</el-button>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="24" v-if="themeBasic.skuDTOList&&themeBasic.skuDTOList.length>0">
              活动SKU： <span v-for="(item,index) of themeBasic.skuDTOList" :key="item.skuCode">{{(index===0?'':'、')+ item.skuName }}</span>
              <!-- <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                :content="getSkuName">
                <el-button size="mini" slot="reference">查看</el-button>
              </el-popover> -->
            </el-col>
          </el-row>
          <!-- <div class="pr-item">
            <div>
              PR信息：{{(themeBasic.gpPrDTO&&themeBasic.gpPrDTO.prNumber)+'_'+(themeBasic.gpPrDTO&&themeBasic.gpPrDTO.prName)}}
              &ensp;&ensp;&ensp;
              品牌信息：{{themeBasic.gpPrDTO&&themeBasic.gpPrDTO.brandName+'-'+themeBasic.gpPrDTO&&themeBasic.gpPrDTO.subBrandName}}
            </div>
          </div>
          <div>
            <span>活动执行数据收集模板</span>
            <el-button type="text" style="margin-left:10px;" @click="$refs['ConfigureExecutionData'].handleOpen()">{{ '查看配置' }}</el-button>
          </div> -->
        </div>
      </div>

      <div v-for="channelItem of themeChannelCodes" :key="channelItem">
        <!-- <ActivityThemeStyle :themeName="themeBasic.themeName" :channelConfig="getChannelConfig(channelItem)" :saveInfo="getSaveInfo(channelItem)" @submitDetail="handleReceiveDetail"
          @handleStyleChange="handleStyleChange" @handleAddChangeList="handleAddChangeList" :saveChannelSkuDTOList="getSaveChannelSkuDTOList(channelItem)" :themeId="themeId" :themeBasic="themeBasic" :isOwner="isOwner" :btmpSkuDTOList="btmpSkuDTOList" /> -->
        <ActivityThemeStyle :channelAssignVOSLength="channelAssignVOS.length" :regionOrgList="regionOrgList" :channelConfig="getChannelConfig(channelItem)" :saveInfo="getSaveInfo(channelItem)" :saveChannelSkuDTOList="getSaveChannelSkuDTOList(channelItem)" @submitDetail="handleReceiveDetail"
          @handleStyleChange="handleStyleChange" @handleChangeStatus="handleChangeStatus" :themeId="themeId" :themeBasic="themeBasic"  :isOwner="isOwner" :btmpSkuDTOList="btmpSkuDTOList"/>
      </div>

    </div>

    <ConfigureExecutionData class="configure-execution" ref="ConfigureExecutionData"  :readonly="true" :themeId="themeId"></ConfigureExecutionData>
  </div>
</template>
<script>
//import FileUpload from './components/file-upload'
import gameplanApi from "@/api/gameplan";
import ContentHeader from "@/components/content-header";
import { mapGetters,mapState } from 'vuex'
import { commonUtils } from '@/utils/common'
//import ActivityThemeStyle from './components/activity-theme-style.vue'
import ActivityThemeStyle from './components/activity-theme-style.vue'
import ConfigureExecutionData from './components/configure-execution-data'
export default {
  name:"configure-theme-detail",
  components: {
    ContentHeader,
    //FileUpload,
    ActivityThemeStyle,
    ConfigureExecutionData
  },
  data() {
    return {
      detailList:{},
      saveDetailList:[],
      loading:false,
      employeeLevel: '',
      operateType:'',
      themeBasic: {},
      oldThemeTime: [],
      themeTime: [],
      applyTime: [],
      fullConfig: [],
      themeChannelCodes:[],
      themeChannelChecked:[],
      themeChannelNames: [],
      themeInfo:{},
      themeId:'',
      channelSkuDTOList:[],
      btmpSkuDTOList:[],
      prInfo:'',
      brandInfo:'',
      themeDetailStatus:500,
      changeList:[],
      channelAssignVOS:[],
      regionOrgList:[],
    };
  },
  computed: {
    ...mapState({
      fileUploadTarget: state => state.app.fileUploadTarget,
    }),
    ...mapGetters(['userInfo']),
    isOwner(){
      return this.userInfo.employeeCode===this.themeBasic.themeOwnerCode
    },
    isHQ(){
      return this.employeeLevel>=90
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
    getOrgLevel(){
      if(this.themeBasic.orgLevel&&this.themeBasic.orgLevel.length===2) return this.themeBasic.orgLevel.toUpperCase()
      else return 'Region'
    },
    isBUChangeAssign(){
      let result = false
      this.saveDetailList.forEach(detail=>{
        if(detail.curAssignList&&detail.curAssignList.length>0){
          if(detail.curAssignList[0].assignStatus===30) result = true
        }
      })
      return result
    }
  },
  created() {
    this.themeId = this.$route.query.themeId || ''
    this.employeeLevel = this.userInfo.employeeLevel
    this.init()
  },
  methods: {
    addThemeInfo(){
      this.$router.push({ name:'configure-theme-info',query:{themeId:this.themeId} })
    },
    openFile(type){
      if(type === 'execTemplateUri'){
        window.open(commonUtils.getImageUrl(this.themeBasic.execTemplateUri))
      }else if(type === 'manualFileUri'){
        window.open(commonUtils.getImageUrl(this.themeBasic.manualFileUri))
      }
    },
    connectVendor(){
      this.$router.push({ name:'PO-connect',query:{themeId:this.themeId}})
    },
    getChannelConfig(themeChannelCode){
      return this.fullConfig.find(val=>{
        return themeChannelCode===val.themeChannelCode
      })
    },
    getSaveInfo(themeChannelCode){
      const data = this.saveDetailList.filter(val=>{
        return themeChannelCode===(val.themeDetail?.themeChannelCode)
      })
      return data || {}
    },
    getSaveChannelSkuDTOList(themeChannelCode){
      // console.log(this.saveChannelSkuDTOList);
      const data = this.channelSkuDTOList.find(val=>{
        return themeChannelCode===(val.channelCode)
      })
      return data || {}
    },
    handleReceiveDetail(data,itemKey){
      this.$set(this.detailList,itemKey,data)
      //this.detailList
    },
    handleStyleChange(themeStylesList,themeChannelCode){
      this.$nextTick(function () {
        let styleInfo = this.detailList[themeChannelCode] || {}
        let styleCodeList = Object.keys(styleInfo)
        styleCodeList.forEach(item=>{
          if(themeStylesList.indexOf(item)===-1){
            this.$delete(styleInfo,item)
          }
        })
      });
    },
    init(){
      // this.$store.dispatch('getGameplanConfigIgniteOptions')
      this.employeeLevel = this.userInfo.employeeLevel
      this.$store.dispatch('getGameplanDecorateConstructMap')
      this.$store.dispatch('getGameplanDecorateExecDecorateMap')
      this.$store.dispatch('getGameplanDecorateMap')
      if(this.isHQ) this.$store.dispatch('getGameplanCityPoolBaseOrgBuList')
      else if(this.isBU) this.$store.dispatch('getGameplanCityPoolBaseOrgRegionList',{buOrgId:this.userInfo.orgDTO.parentOrgId})
      else if(this.isRegion){
        //this.$store.dispatch('getGameplanCityPoolBaseOrgAreaList',{buOrgId:this.userInfo.orgDTO.parentOrgId,regionOrgId:this.userInfo.orgDTO.orgId})
        this.$store.dispatch('getThemeRegionList')
      }
      this.getGameplanConfigFull()
      this.getGameplanThemeChannelAssign()
    },
    getShowDetail(){
      let brandInfo = []
      let prInfo = []
      const gpPrDTOList = this.themeBasic.gpPrDTOList
      if(gpPrDTOList){
        gpPrDTOList.forEach(item=>{
          let data = ''
          if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
          else data = item.brandName||item.subBrandName
          if(brandInfo.indexOf(data)===-1) {
            brandInfo.push(data)
          }
          prInfo.push(item.prNumber+'-'+item.prName)
        })
        this.brandInfo = brandInfo.join('、')
        this.prInfo = prInfo.join('、')
      }
    },
    async getGameplanThemeInfo(themeId) {
      this.saveDetailList = []
      this.loading = true
      let params = {
        themeId:themeId,
        detailOrConfig:2
      }
      const { data } = await gameplanApi.getGameplanThemeInfo(params);
      if (data.resultCode === "0") {
        this.themeBasic = data.resultData?.themeInfo.themeBasic || {}
        this.saveDetailList = data.resultData?.themeInfo.detailList || []
        this.channelSkuDTOList = data.resultData?.themeInfo.channelSkuDTOList || []
        this.btmpSkuDTOList = data.resultData?.themeInfo.btmpSkuDTOList || []
        this.saveDetailList.forEach(item=>{
          this.themeChannelCodes.indexOf(item.themeDetail.themeChannelCode)===-1?this.themeChannelCodes.push(item.themeDetail.themeChannelCode):''
          if(item.themeDetail.themeDetailStatus){
            this.themeChannelChecked.indexOf(item.themeDetail.themeChannelCode)===-1?this.themeChannelChecked.push(item.themeDetail.themeChannelCode):''
          }
        })
        this.themeDetailStatus = this.saveDetailList&&this.saveDetailList[0].themeDetail.themeDetailStatus
        this.getShowDetail()
      }
      this.loading = false
    },
    async getGameplanConfigFull() {
      this.loading = true
      const { data } = await gameplanApi.getGameplanConfigFull();
      if (data.resultCode === "0") {
        this.fullConfig = data.resultData?.fullConfig || [];
        //this.assignBuList = data.resultData?.assignBuList || []
        //this.assignRegionList = data.resultData?.assignRegionList || []
        //this.assignAreaList = data.resultData?.assignAreaList || []
        //this.total = data.resultData.pageInfo.totalCounts
      }
      if(this.themeId){
        this.getGameplanThemeInfo(this.themeId)
      }else {
        this.loading = false
      }
    },
    async getGameplanThemeChannelAssign(){
      const params = { themeId:this.themeId}
      const { data } = await gameplanApi.getGameplanThemeChannelAssign(params);
      if (data.resultCode === "0") {
        this.channelAssignVOS = data.resultData?.channelAssignVOS || []
      }
    },
    handleChangeStatus(){
      this.getGameplanConfigFull()
      this.getGameplanThemeInfo(this.themeId,'themeId',2)
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #fdfdfd !important;
    border-color: #DCDFE6 !important;
    color: rgb(255, 255, 255) !important;
    cursor: not-allowed;
}
::v-deep .configure-execution .el-checkbox__input.is-checked .el-checkbox__inner,
 .configure-execution .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #a3a3a3 !important;
  border-color: #c0c0c0 !important;
}
::v-deep .el-checkbox {
    &.is-checked {
      .el-checkbox__inner {
        &::after {
          border-color: #ffffff;
        }
      }
    }
  }

.pr-box{
  width: calc(100% - 50px);
  padding: 15px 25px 15px 25px;
  background-color: #ffffff;
  border-radius: 8px;
  .pr-item{
    display: flex;
    flex-wrap: wrap;
    //margin-bottom: 12px;
  }
  .flex{
    display:flex;
    flex-wrap:wrap;
  }
  .space-between{
    justify-content: space-between;
  }
  .pr-title{
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
  }
  .pr-level{
    color: white;
    display: inline-block;
    font-size: 14px;
    line-height: 18px;
    padding: 0 10px;
    background-color: rgb(71, 172, 255);
  }
  .pr-status {
    color: rgb(192, 1, 1);
    font-size: 16px;
    font-weight: 600;
  }
}
.operation_btn_box{
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: flex-end;
  top: 0px;
  .operate_btn{
    text-align: center;
    padding: 5px 12px;
    border-radius: 4px;
    margin: -5px 0  0 10px;
    cursor: pointer;
  }
  .operate_btn_red {
    color: white;
    background-color: rgb(214, 0, 0);
  }
  .operate_btn_white{
    color: rgb(214, 0, 0);
    background-color: white;
    border: 1px solid rgb(214, 0, 0);
  }
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409eff;
  border-color: #409eff;
}

::v-deep .el-checkbox__inner:hover,
::v-deep .el-checkbox__input .el-checkbox__inner:focus {
  border-color: #409eff !important;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner,
::v-deep .el-checkbox__input.is-focus .el-checkbox__inner:hover {
  border-color: #409eff !important;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #101010;
}

::v-deep .activity_new .el-form-item {
  min-width: 48%;
  margin-bottom: 24px;

  .el-form-item__label {
    color: black;
  }
}
::v-deep .el-checkbox__input {
    margin-top: -8px;
}

::v-deep .el-checkbox__label {
    margin-top: -2px;
}
.content-wrapper {

  .activity_new {
    position: relative;
    margin-top: -50px;

    .activity-new-card {
      padding: 20px 10px 20px 0px;
      background-color: #ffffff;
      color: #101010;
      border-radius: 10px;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      font-family: SourceHanSansSC-bold;
      display: flex;
      justify-content: flex-start;

      .po_config_btn {
        cursor: pointer;
        position: absolute;
        right: 0;
        top: -25px;
        width: 120px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        background-color: #539efe;
        color: #ffffff;
        font-size: 14px;
        text-align: center;
        font-family: Roboto;
      }
    }

    .activity_channel_checkbox {
      margin: -5px 0 20px 40px;
    }

    .activity_channel_checkbox_label {
      text-align: center;
      position: relative;
      top: 15px;
      line-height: 18px;
    }
  }
}

.upload_section {
  margin: 30px 0 0 8px;
  font-size: 12px;
}
.upload_item {
    display: flex;
    margin-left: 30px;
  }

  .upload_item_title {
    width: 220px;
    font-size: 14px;
    font-weight: 600;
    padding: 20px 10px;
  }

  .upload_item_btn {
    cursor: pointer;
    margin-top: 13px;
    height: 30px;
    line-height: 30px;
    width: 100px;
    border-radius: 5px;
    text-align: center;
    vertical-align: middle;
    color: white;
    background-color: rgb(204, 0, 0);
  }

.btn_section{
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 15px;
  text-align: center;
  margin-top: 60px;
  .normal_btn{
    width: 100px;
    padding: 10px 0;
    border-radius: 5px;
    cursor: pointer;
  }
  .btn_bg_white{
    border: 1px solid rgb(204, 0, 0);
    color: rgb(204, 0, 0);
    margin-right: 100px;
  }
  .btn_bg_white_disadled{
    border: 1px solid $base-grey4 !important;
    color: $base-grey4 !important;
    cursor: no-drop;
    margin-right: 100px;
  }
  .btn_bg_red{
    color: white;
    background-color: rgb(204, 0, 0);
    border: 1px solid rgb(204, 0, 0);
  }
  .btn_bg_red_disabled{
    color: white;
    cursor: no-drop;
    background-color: $base-grey4 !important;
    border: 1px solid $base-grey4 !important;
  }
}
</style>
